//--- remove this customized file when upgrade to io-comune 3.3.20
const MessageFilterBlocks = () => {
  return <></>;
};

export default MessageFilterBlocks;
